import dynamic from 'next/dynamic';
import React from 'react';
import { ProgressiveImage } from '../../types';
import GalleryItemOverlay from '../GalleryItemOverlay/GalleryItemOverlay';
import { GalleryItemProps } from '../types';
import { isMobile } from '../../../utils/browser-utils';
import classes from './galleryItem.module.scss';

const CanvasImage = dynamic<ProgressiveImage>(
  () => import('@apester/image').then((mod) => mod.CanvasImage), { ssr: false },
);

const GalleryItem: React.FC<GalleryItemProps> = ({
  template, templateIndex, sectionName, needs,
}) => {
  const { thumb: { path }, name } = template;
  const { text, gridItem, dark } = classes;
  const [isHover, setHover] = React.useState(false);

  return (
         <div className={gridItem}
           onMouseEnter={() => setHover(true)}
           onMouseLeave={() => setHover(false)}
         >
           <div className={dark}/>
            <CanvasImage isBackground={true} src={path} miscStyles={{
              position: 'absolute', height: '100%', width: '100%',
            }} />
           { (isHover || isMobile()) && (
            <GalleryItemOverlay
              templateIndex={templateIndex}
              template={template}
              sectionName={sectionName}
              needs={needs}
            />)}
           <p className={text} style={{ zIndex: 1 }}>
             {name}
           </p>
        </div>
  );
};

export default GalleryItem;
